import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotScrollSection from './components/HotScrollSection';
import CategoriesSection from './components/CategoriesSection';
import LatestGridSection from './components/LatestGridSection';
import CommentSection from './components/CommentSection';
import CTASection from './components/CTASection';

const siteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17吃瓜',
  url: 'https://17chigua.com',
  description: '17吃瓜品牌主页，聚合17吃瓜网、17吃瓜爆料、17吃瓜黑料等最全吃瓜入口，实时更新网红黑料、塌房现场与每日大瓜事件。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://17chigua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '17吃瓜',
  url: 'https://17chigua.com',
  description: '17吃瓜是国内领先的网红八卦与娱乐黑料实时更新平台，聚合全网最新最全的吃瓜资讯。',
  foundingDate: '2023',
  sameAs: [
    'https://weibo.com/17chigua',
    'https://weixin.qq.com/17chigua',
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://17chigua.com' },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotScrollSection />
        <CategoriesSection />
        <LatestGridSection />
        <CommentSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}